import { B } from "../../design/tokens";
import { PHOTOS } from "../shared/constants";
import Reveal from "../shared/Reveal";
import Tag from "../shared/Tag";

export default function AboutSection() {
  const values = [
    { icon: "◈", title: "Professional Integrity",  desc: "PRC-licensed, SEC-registered — every transaction upholds the highest professional and regulatory standards." },
    { icon: "◉", title: "Full Transparency",        desc: "Fixed-rate tariff, no hidden charges. All out-of-pocket expenses fully receipted and refunded if unused." },
    { icon: "◐", title: "Client-Centered Service",  desc: "From individual property owners to LGUs — every engagement tailored to your specific needs and timeline." },
    { icon: "◫", title: "Nationwide Reach",          desc: "Full coverage from Metro Manila to Visayas and Mindanao, including remote LGU engagements." },
  ];
  return (
    <section id="about" style={{ background: B.white, padding: "120px 0", overflow: "hidden", position: "relative" }}>
      <div style={{ position: "absolute", bottom: 0, left: 0, width: "50%", height: "40%", background: `radial-gradient(circle at bottom left, ${B.pale}88 0%, transparent 70%)`, pointerEvents: "none" }} />
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 32px", position: "relative", zIndex: 2 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }} className="about-grid">
          <Reveal from="left">
            <div style={{ position: "relative" }}>
              <div style={{ width: "100%", aspectRatio: "4/3", backgroundImage: `url(${PHOTOS.about})`, backgroundSize: "cover", backgroundPosition: "center", boxShadow: `0 24px 64px ${B.navy}22` }} />
              <div style={{ position: "absolute", top: -12, left: -12, width: 64, height: 64, border: `3px solid ${B.azure}`, borderRight: "none", borderBottom: "none" }} />
            </div>
          </Reveal>
          <Reveal from="right" delay={0.12}>
            <Tag text="About the Firm" />
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(32px, 3.8vw, 50px)", fontWeight: 700, color: B.navy, lineHeight: 1.1, letterSpacing: -0.5, marginBottom: 24 }}>
              Integrated Real Estate &<br /><em style={{ color: B.azure }}>Environmental Planning</em>
            </h2>
            <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 15.5, color: B.slate, lineHeight: 1.9, marginBottom: 18 }}>
              <strong style={{ color: B.navy }}>NESW Property & Planning Consultancy OPC</strong> is a Philippine-registered One Person Corporation providing integrated real estate and environmental planning services nationwide.
            </p>
            <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 15.5, color: B.slate, lineHeight: 1.9, marginBottom: 36 }}>
              Led by <strong style={{ color: B.navy }}>Jessamyn Dela Cruz Rubio</strong> — PRC-licensed Real Estate Broker (Lic. No. 32905), Appraiser, and licensed Environmental Planner. A rare combination unmatched in a single Philippine firm.
            </p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 36 }}>
              {values.map((v, i) => (
                <div key={i} style={{ padding: "18px 16px", background: B.ghost, border: `1.5px solid ${B.pale}`, transition: "all 0.25s" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = `${B.azure}44`; e.currentTarget.style.background = B.pale; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = B.pale; e.currentTarget.style.background = B.ghost; }}
                >
                  <div style={{ fontFamily: "'Space Grotesk', sans-serif", color: B.azure, fontSize: 18, marginBottom: 8, lineHeight: 1 }}>{v.icon}</div>
                  <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 13.5, fontWeight: 700, color: B.navy, marginBottom: 5 }}>{v.title}</div>
                  <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12.5, color: B.slate, lineHeight: 1.65 }}>{v.desc}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
